import React, { useState } from 'react';

import { Row, Col } from 'antd';
import Axios from 'axios';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import styled from 'styled-components';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import useFormFieldFocus from '@hooks/Utils/UseFormFieldFocus';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWInput } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const StyledRow = styled(Row)`
    .ant-input-number {
        width: 100%;
    }
`;

const ModelAgencyCommissionDrawer = ({ networkAgency, model, onSetModel, onClose }) => {
    useFormFieldFocus('Commission');
    const [touchForm, setTouchForm] = useState(false);

    const initialValues = {
        Commission: networkAgency.ModelCommission,
    };

    const saveNetworkAgencyCommission = async (values, setSubmitting) => {
        setSubmitting(true);

        try {
            await Axios.post('/models/setCommission', {
                ContactID: networkAgency.ContactID,
                NetworkAgencyID: networkAgency.NetworkAgencyID,
                Commission: parseFloat(values.Commission).toFixed(2),
            });
            if (model.NWAGS) {
                const networkAgencyIndex = model.NWAGS.findIndex((agency) => agency.ID === networkAgency.ID);
                let updatedModel = { ...model };
                updatedModel.NWAGS[networkAgencyIndex].ModelCommission = parseFloat(values.Commission).toFixed(2);
                onSetModel(updatedModel);
            } else {
                forceReloadContact(model.ID);
            }
            setSubmitting(false);
            onClose();
        } catch (error) {
            console.error('Update Network Agency Commission Error => ', error);
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} title={'Edit Agency Commission'} onClose={onClose}>
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                    Commission: Yup.number()
                        .typeError('Commission must be a number')
                        .required('Commission is required, add zero for no commission')
                        .min(0, 'Please input correct percentage, it should be between 0 and 99.99')
                        .max(99.99, 'Please input correct percentage, it should be between 0 and 99.99')
                        .test('max-two-decimals', 'Please input only two decimals', (value) => {
                            if (value === undefined || value === null) {
                                return true;
                            }
                            return /^\d+(\.\d{1,2})?$/.test(String(value));
                        }),
                })}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    saveNetworkAgencyCommission(values, setSubmitting);
                }}
            >
                {({ isSubmitting, isValid, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit} layout="vertical">
                        <StyledRow>
                            <Col lg={12} md={12} sm={12} xs={24}>
                                <Field
                                    component={NWInput}
                                    label="Commission"
                                    name="Commission"
                                    type="text"
                                    value={values.Commission}
                                />
                            </Col>
                        </StyledRow>
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={
                                <NwSaveButton
                                    htmlType="submit"
                                    disabled={!isValid || isSubmitting}
                                    loading={isSubmitting}
                                />
                            }
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default ModelAgencyCommissionDrawer;
